<script setup lang="ts">
import {computed, onMounted, PropType, ref, useTemplateRef} from "vue";
import {ICellEditorParams} from "ag-grid-community";
import {date, QInput, QMenu} from "quasar";
import CalenderIcon from "@/assets/widgetIcons/CalendarIcon.vue";
import dayjs, {ISO_DATE_FORMATS} from "@/utils/dayjs";
import Translator from "@/utils/common/Translator.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";

const props = defineProps({
  params: {
    type: Object as PropType<ICellEditorParams>,
    required: true
  }
});
const qDateInput = useTemplateRef<QInput>("qDateInput");
let inputDate = ref(props.params.value ? props.params.formatValue(props.params.value) : '');
let selectedDate = ref(inputDate.value);
const dateMenuState = ref<boolean>(false);
const today = new Date();
const padZero = (num: number) => (num < 10 ? `0${num}` : num);
const formattedDate = `${today.getFullYear()}/${padZero(today.getMonth() + 1)}`;
const defaultDate = ref(formattedDate);

const selectedDateForTitle = computed(() => {
  let timeStamp: string | Date = selectedDate.value ? selectedDate.value : new Date();
  const dayjsValue = timeStamp instanceof Date ? dayjs(timeStamp) : dayjs(timeStamp, ISO_DATE_FORMATS);
  return date.formatDate(dayjsValue.format("YYYY-MM-DD"), Translator.isArabic() ? 'dddd, D MMMM' : 'dddd, D MMM');
});

function getValue() {
  return props.params.parseValue(inputDate.value);
}

onMounted(() => {
  if (qDateInput.value) {
    setTimeout(() => {
      qDateInput.value?.focus();
      qDateInput.value?.select();
      if (props.params?.eventKey?.length === 1) {
        inputDate.value = props.params?.eventKey;
      }
    })
  }
});

function onDateSelect(newValue: any) {
  inputDate.value = newValue;
  selectedDate.value = newValue;
  dateMenuState.value = false;
}

function onPartialUserInput(val) {
  inputDate.value = val;
}

function onClosePopupClicked(e) {
  props.params?.stopEditing();
}

function namaUpdateValue(value: string) {
  inputDate.value = value;
}

function onKeyDown(event: KeyboardEvent) {
  if (AGGridUtils.isBulkAction(event)) {
    namaUpdateValue(getValue());
    AGGridUtils.dispatchBulkEventFor(qDateInput);
  }
  else if (event.key == "F2") {
    props.params?.api.stopEditing();
  }
}

function onDateIconClick() {
  dateMenuState.value = true;
}

function onFocus() {
  dateMenuState.value = true;
}

defineExpose({getValue, namaUpdateValue});
</script>
<template>
  <q-input ref="qDateInput" hide-bottom-space dense :model-value="inputDate" @update:model-value="onPartialUserInput"
           autocomplete="off" enterkeyhint="go"
           class="ag-custom-component-popup nama-field-input nama-customize-dense-input nama-focused-input nama-dark-popup"
           input-class="tw-bg-transparent focus:tw-ring-0 focus:tw-shadow-none focus:tw-border-none dark:tw-text-namaFontColor-input-dark
      dark:tw-placeholder-gray-300"
           @keydown="onKeyDown" @focus="onFocus">
    <template v-slot:append>
      <q-avatar square class="tw-cursor-pointer nama-avatar-hover" :clickable="false">
        <CalenderIcon @click.stop="onDateIconClick" class="tw-size-4  nama-widget-icon-hover nama-widget-icon"/>
        <q-menu v-model="dateMenuState" ref="menuRef" anchor="bottom left" self="top left" no-focus no-refocus no-parent-event
                class="tw-bg-transparent">
          <q-date mask="DD-MM-YYYY" :model-value="selectedDate" @update:model-value="onDateSelect" today-btn
                  :default-year-month="defaultDate" :title="selectedDateForTitle"
                  class="nama-date tw-text-namaBlack tw-bg-namaBackground-deep-light dark:tw-text-namaFontColor-input-dark dark:tw-bg-namaBackground-dim-dark">
          </q-date>
        </q-menu>
      </q-avatar>
    </template>
  </q-input>
</template>

<style scoped>

</style>
